<template>
    <section class="block-cta">
        <div class="block-cta__main">
            <div class="block-cta__content">
                <div class="block-cta__content-text">
                    <h2 v-html="$t('blockcta.title')"></h2>
                    <p>{{ $t('blockcta.paragraph') }}</p>
                </div>
                <div class="block-cta__content-button">
                    <a :href="$t('blockcta.linkurl')" target="_blank" class="btn btn-fullwidth btn-gradient">{{ $t('blockcta.linklabel') }}</a>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
  name: 'Blockcta',
};
</script>
